import {

  Component,
} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {MessageService} from "primeng/api";
import {DateFormatLangPipe} from "@app/utils/pipes/date-format-lang-pipe";
import {MsfSelect} from "@components/select/select";
import {FormsModule} from "@angular/forms";
import {MsfInput} from "@components/ui/forms/input/input";

import { ButtonDirective} from "primeng/button";
import {Divider} from "primeng/divider";
import {DatePipe, NgIf} from "@angular/common";
import {CheckboxComponent} from "@components/checkbox";
import {TextareaComponent} from "@components/textarea";
import {GetByIdPipe} from "@app/utils/pipes/get-by-id-pipe";
import {DatePickerComponent} from "@components/date-picker";
import {DialogComponent} from "@components/dialog";


import {RequestMapComponent} from "@components/request-map/request-map.component2";
import {GroundSurvey} from "@app/pages/crop-monitoring/components/request-add-page/forms/ground-surver/ground-survey";
import {CustomMessageService} from '@app/interceptors/custom-message';


@Component({
  selector: 'app-uav',
  standalone: true,
  templateUrl: './uav.html',
  styleUrl: './uav.scss',
  providers: [
    TranslatePipe,
    DateFormatLangPipe,
    {
      provide: MessageService,
      useClass: CustomMessageService
    },
    DatePipe
  ],
  imports: [
    TranslatePipe,
    DateFormatLangPipe,
    MsfSelect,
    FormsModule,
    MsfInput,
    ButtonDirective,
    Divider, NgIf,
    CheckboxComponent,
    TextareaComponent, GetByIdPipe,
    DatePickerComponent,
    DialogComponent,
    RequestMapComponent
  ]
})
export class Uav extends GroundSurvey {


  override loadFieldByPoints(dialogMode = true, lat = this.formData.lat, lng = this.formData.lng) {

  }
}
